export const appid = "wx6432ceda6ead9580";
export const storeKey = 'hlab0904-final-1';
export const apiUrl = 'https://digital2.rabbitpre.com/hla-baoxue/api';
// design height
export const heightS = 1100;
export const heightM = 1300;
export const heightB = 1500;

//fibo
export const fiboPfid = 'mk_suikMyVs';
export const fiboAppid = '232a2542-e7f9-4732-8d7d-4d9be38d1089';